/**
 * Takes a string with named formatters {TEST}-{A}-{B}
 * and a dictionary with TEST=>Value1, A=>Value2, B=>Value3
 * and interpolates the values
 *
 * Returns {Value1}-{Value2}-{Value3}
 *
 *
 * @param {String} text Text to interpolate
 * @param {Object} dict Dictionary with the values
 * @returns {String} Iterpolated string
 */
export function interpolateByDictionary(text, dict) {
    if (!_.isObject(dict)) {
        return '';
    }

    return Object.keys(dict).reduce((result, key) =>
        result.replace(`{${key}}`, dict[key]), text);
}

export function isBlank(str) {
    // undefined or null
    if (!str) {
        return true;
    }

    // booleans
    if (_.isBoolean(str)) {
        return false;
    }

    // numbers
    if (_.isNumber(str)) {
        return false;
    }

    // empty arrays or objects
    if (!_.isString(str) && _.isEmpty(str)) {
        return true;
    }

    // empty strings or those with just whitespace
    if (_.isString(str) && _.isEmpty(_.trim(str))) {
        return true;
    }

    return false;
}

export function isBlankString(str) {
    // if argument is not a string, we most likely want this to return true
    // because anticipated use is to check if it's a string and that it's not empty or all whitespace
    if (!_.isString(str)) {
        return true;
    }

    return isBlank(str);
}
